import type { CitationSpan, LinkedItem, LinkedSpan, Resolution } from '../types';
import type { OrdinalIndex } from './ordinal-index';

/** Resolve one ordinal against the index. */
export function resolveOrdinal(ordinal: number, index: OrdinalIndex): Resolution {
  if (index.status !== 'ok') return { kind: 'unresolved', reason: `the bibliography could not be numbered: ${index.reason}` };
  const id = index.byOrdinal.get(ordinal);
  if (!id) return { kind: 'unresolved', reason: `no reference is numbered ${ordinal}` };
  return { kind: 'resolved', id, score: 1, evidence: [`ordinal:${ordinal}`] };
}

/**
 * Resolve every ordinal of a numeric span. The span is `linked` only when every ordinal maps;
 * one missing ordinal makes the whole span `partial` and nothing in it may be linked — half a
 * combined token would lose the author's grouping. Items follow the order written.
 */
export function resolveNumericSpan(span: CitationSpan, index: OrdinalIndex): LinkedSpan {
  const items: LinkedItem[] = span.constituents.map((constituent) => ({
    constituent,
    resolution: constituent.ordinal === undefined
      ? { kind: 'unresolved', reason: 'the constituent carries no ordinal' }
      : resolveOrdinal(constituent.ordinal, index),
  }));
  const kind = items.every((i) => i.resolution.kind === 'resolved') ? 'linked' : 'partial';
  return { span, kind, items };
}
